import { emptyPatientQuestionnaireDraft } from "@emr/contracts";
import type { IntakeData } from "../types";

/** A blank questionnaire: Ontario address, no coverage chosen. */
export const emptyIntake: IntakeData = emptyPatientQuestionnaireDraft();
